/**
 * Impostazioni: i pezzi comuni a tutte le sezioni.
 */

import type { ReactNode } from "react";
import { User } from "lucide-react";
import { Card } from "../../ui/primitives.tsx";

/** Una scheda con icona, titolo e due righe: tutte le sezioni la usano uguale. */
export function Scheda({
  Icona,
  titolo,
  testo,
  azione,
  children,
}: {
  Icona: typeof User;
  titolo: string;
  testo?: ReactNode;
  azione?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <Card className="p-5">
      {/* A capo quando lo spazio manca: su due colonne il bottone accanto al
          titolo schiacciava il testo in una colonnina di tre parole. */}
      <div className="flex flex-wrap items-start gap-3">
        <span className="grid size-9 shrink-0 place-items-center rounded-field bg-surface-muted text-ink-soft">
          <Icona size={16} />
        </span>
        <div className="min-w-[220px] flex-1">
          <p className="text-[15px] font-bold text-ink">{titolo}</p>
          {testo ? (
            <p className="mt-0.5 text-[13px] leading-relaxed text-ink-soft">
              {testo}
            </p>
          ) : null}
        </div>
        {azione ? <div className="shrink-0">{azione}</div> : null}
      </div>
      {children ? <div className="mt-4">{children}</div> : null}
    </Card>
  );
}
